import { render, staticRenderFns } from "./NoticeBarPreview.vue?vue&type=template&id=337d1dcc&scoped=true&"
import script from "./NoticeBarPreview.vue?vue&type=script&lang=js&"
export * from "./NoticeBarPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d1dcc",
  null
  
)

export default component.exports